import { API_ENDPOINTS } from '@/constants';
import { apiRequest } from '@/services/client';
import type { ApiMessageResponse } from '@/types/api';

type UpdatePasswordPayload = {
  current_password: string;
  password: string;
};

export const updateCurrentUserPassword = async (
  body: UpdatePasswordPayload,
): Promise<ApiMessageResponse> => {
  return apiRequest<ApiMessageResponse>(API_ENDPOINTS.USERS.PASSWORD.UPDATE, {
    method: 'PATCH',
    data: body,
    retry: { retries: 0 },
  });
};
